///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { AttachedFileDTO } from '../../../../../generated/shared-types.model';
import { GtthNodeFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-node-feature-dto.model';
import { GtthLinkFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-link-feature-dto.model';

export class GtthImportVerificationCommand extends GtthAbstractCommand {
    private attachedFile: AttachedFileDTO;

    private importResult: ActivityDTO;

    getCommandName(): string {
        return 'GtthImportVerificationCommand';
    }

    create(importFile: AttachedFileDTO): this {
        this.attachedFile = importFile;
        return this;
    }

    protected doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const importActivity = this.createActivityDTO(false);
        importActivity.attachedFile = this.attachedFile;
        this.sendActivity(importActivity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        this.importResult = activityDto;

        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.hide()
        });

        if (!activityDto.successful) {
            this.historyService.notificationService.showError(activityDto?.error?.message);
        }
        if (this.commandResolve) {
            this.commandResolve(activityDto.successful);
        }
    }

    public getResultNodes(): GtthNodeFeatureDtoModel[] {
        return this.importResult.nodes;
    }

    public getResultLinks(): GtthLinkFeatureDtoModel[] {
        return this.importResult.links;
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
